
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seja-um-parceiro",
      function () {
        return require("private-next-pages/seja-um-parceiro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seja-um-parceiro"])
      });
    }
  